import IconButton from "./IconButton";

import { ReactComponent as FavouriteIcon } from "../../../../static/images/icons/favourite.svg";

export default function FavouriteButton({ pos }) {
    return <IconButton DefaultIcon={FavouriteIcon} style={pos} label={0} />;
}
